export enum ManifestType {
  EMPTY = "",
  MANUSCRIPT = "manuscript",
  MONOGRAPH = "monograph",
}
